module.exports = __webpack_public_path__ + "static/media/-4.5d21cc30.png";